import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Planificás sin ejemplos argentinos',
    perdes: 'Alumnos desconectados que no le ven sentido a la materia'
  }, {
    sin: 'Sin banco de actividades contextualizadas',
    perdes: 'Horas semanales perdidas armando material de cero'
  }, {
    sin: 'Sin proyectos institucionales listos',
    perdes: 'Querés hacer algo real pero siempre quedás en la intención'
  }, {
    sin: 'Sin banco de evaluaciones',
    perdes: 'Evaluaciones repetidas que no miden lo que realmente importa'
  }, {
    sin: 'Sin efemérides armadas',
    perdes: 'Actos escolares improvisados que no generan impacto'
  }, {
    sin: 'Sin conexión con la actualidad',
    perdes: 'Alumnos que no entienden para qué sirve lo que aprenden'
  }, {
    sin: 'Sin marco legal actualizado',
    perdes: 'No sabés cómo responder si la inspección pregunta por la Ley 27.621'
  }, {
    sin: 'Sin material imprimible',
    perdes: 'Horas de diseño y edición que podrían dedicarse a enseñar'
  }];
  return <section className="py-20 bg-[#f5efe1] text-[#1e4230]" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-black mb-4 font-[Merriweather,_serif]" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 border border-[#e0d6bf] mb-12 max-w-3xl mx-auto shadow-[0_12px_30px_-18px_rgba(31,50,39,0.3)]" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-6 pb-4 border-b border-[#e0d6bf]" data-id="element-23">
            <div className="font-bold text-[#6f4e2e] uppercase text-sm tracking-wider" data-id="element-24">
              Sin el Megapack
            </div>
            <div className="font-bold text-[#9c3f22] uppercase text-sm tracking-wider" data-id="element-25">
              Lo que realmente perdés
            </div>
          </div>
          <ul className="space-y-6" data-id="element-26">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-2 gap-4 items-center" data-id="element-27">
                <div className="flex items-start gap-3" data-id="element-28">
                  <div className="mt-1 bg-[#9c3f22]/10 p-1 rounded-full shrink-0 border border-[#e0b48f]" data-id="element-29">
                    <X className="w-4 h-4 text-[#9c3f22]" data-id="element-30" />
                  </div>
                  <span className="text-[#4a4133] text-sm md:text-base" data-id="element-31">
                    {row.sin}
                  </span>
                </div>
                <div className="text-[#9c3f22] text-sm md:text-base font-medium" data-id="element-32">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-[#1e4230] rounded-2xl p-8 md:p-12 shadow-2xl border-2 border-[#c8971b]/50" data-id="element-33">
          <p className="md:text-3xl font-black text-[#f5efe1] text-[20px] mb-6 font-[Merriweather,_serif] leading-snug" data-id="element-34">
            🌿🇦🇷 "La próxima vez que un alumno pregunte para qué sirve la
            Gestión Ambiental, podés mostrarle que Argentina tiene el 21% del
            litio mundial y todavía no lo cuida bien, que el Riachuelo tardó 150
            años en tener una ley que lo proteja, y que los glaciares que dan de
            beber a 3 millones de argentinos se están derritiendo hoy mismo. O
            podés seguir explicando sin ese contexto."
          </p>
        </motion.div>
      </div>
    </section>;
}